// extracted by mini-css-extract-plugin
module.exports = {"squareContainer":"picture_squareContainer__3Be5F","squareImageContainer":"picture_squareImageContainer__2B7ri"};